/* eslint-disable max-len */
import React, { useState } from 'react';
import {
  Box, Container, Typography,
} from '@material-ui/core';
import BasicInfo from 'views/profiles/common/components/BasicInfo';
import ReviewsTitle from 'common/components/ReviewsTitle';
import ReviewCard from 'common/components/ReviewCard';
import { withTranslation } from 'config/i18n';
import dynamic from 'next/dynamic';
import moment from 'moment';
import MotorsForRent from 'views/profiles/common/components/MotorsForRent';
import ERPagination from 'components/ERPagination';
import axios, { API } from 'config/axios';
import { useLayoutLoadingSpinner } from 'components/shared/Layout';
import useHandleResponse from 'utils/useHandleResponse';
import addressFormat from 'common/utils/address/address_format';

const StickyTabBar = dynamic(() => import('views/profiles/common/components/StickyTabBar'), {
  ssr: false,
});

const PrivateOwnerProfileView = (props) => {
  const { t, data } = props;

  const stickyBarItems = [
    {
      label: t('fe_es_profiles:motors'),
      id: 'motors_section',
    },
    {
      label: t('fe_es_profiles:riders_reviews'),
      id: 'riders_reviews',
    },
  ];

  const [reviewsData, setReviewsData] = React.useState(data.rider_reviews);
  const [page, setPage] = useState(1);

  const { handleError } = useHandleResponse();
  const [, setLoading] = useLayoutLoadingSpinner();

  const getReviews = (currentPage, perPage) => {
    setLoading(true);
    axios
      .get(
        API.profile.ownersRiderReviews.replace('{owner_id}', data.id),
        {
          params: {
            page_number: currentPage,
            page_size: perPage,
          },
        },
      )
      .then((res) => {
        setReviewsData(res.data.rider_reviews);
      })
      .catch((error) => {
        handleError(error);
      })
      .then(() => {
        setLoading(false);
      });
  };

  const handleReviewPagination = (value) => {
    setPage(value);
    getReviews(value, 6);
  };

  return (
    <>
      {data && (
      <>
        <Box mt={6.5}>
          <BasicInfo
            userImage={data.avatar_url}
            userName={data.name}
            // userEmail={data.email}
            userID={data.user_id}
            verified
              userRate={data.rating}
              tripsCount={data.trips_count > 1 ? data.trips_count : ''}
            userBio=""
            location={addressFormat({
              country: data.country,
              geo: data.geography?.name,
              region: data.region,
            })}
            joinDate={`${t('fe_es_profiles:joined')} ${moment(data.join_date).format('MMM YYYY')}`}
          />
        </Box>

        <Box mt={6}>
          <StickyTabBar
            userInfo={{
              image: data.avatar_url,
              name: data.name,
            }}
            tabItems={stickyBarItems}
            shareOptions={{
              emailSubject: `Find a perfect ride from ${data.name}`,
              emailBody: 'Check out this awesome host on EagleShare!',
            }}
          />
        </Box>

          <Box id="motors_section" pt={6} pb={7}>
          <MotorsForRent
            vehiclesArr={data.vehicles}
            hourlyVehiclesCount={data.hourly_vehicles_count}
            dailyVehiclesCount={data.daily_vehicles_count}
            userID={data.id}
          />
        </Box>
          {data.rider_reviews_count > 0 && (
            <Container>
              <Box id="riders_reviews">
                <ReviewsTitle
                  title={t('fe_es_profiles:riders_reviews')}
                  rateAvg={data.rating > 0 ? data.rating : null}
                  reviewsCount={data.rider_reviews_count}
                />
                {reviewsData.length > 0 ? (
                  reviewsData.map((review) => (
                    <ReviewCard
                      userImage={review.rider.avatar_url}
                      userName={review.rider.name}
                      reviewDate={moment(review.created_at).format('MMM DD, YYYY h:mm a')}
                      rate={review.rating}
                      bikeName={`${review.vehicle.year} ${review.vehicle.make?.name} ${review.vehicle.model?.name}`}
                      bikeHref={`/${review.vehicle.make.slug}/${review.vehicle.model.slug}/${review.vehicle.geography.slug}/${review.vehicle.id}`}
                      reviewDetails={[
                        {
                          subject: t('fe_es_profiles:bike'),
                          title: review.bike_review.title,
                          description: review.bike_review.body,
                          rating: review.bike_review.rating,
                        },
                        {
                          subject: t('fe_es_profiles:host'),
                          title: review.host_review.title,
                          description: review.host_review.body,
                          rating: review.host_review.rating,
                        },
                      ]}
                    />
                  ))
                ) : (
                  <Box mb={6}>
                    <Typography variant="h5" color="textSecondary">
                      {t('fe_es_profiles:be_first_rent_review')}
                    </Typography>
                  </Box>
                )}
              </Box>
              {data.rider_reviews_count > 6 && (
                <Box mt={5} mb={5}>
                  <ERPagination
                    data={{
                      pages_count: Math.ceil(data.rider_reviews_count / 6),
                      active_page: page,
                    }}
                    handleChange={handleReviewPagination}
                  />
                </Box>
              )}

            </Container>
          )}
      </>
      )}

    </>
  );
};

export default withTranslation('fe_es_profiles')(PrivateOwnerProfileView);
